import React, { useState, useEffect } from "react";
import "./Hero.css";

const slides = [
  {
    img: "/Assets/image1.png",
    title: "Next-Gen Infrastructure",
    description:
      "We are a leading civil engineering firm providing integrated services in design, structural engineering.",
  },
  {
    img: "/Assets/image2.png",
    title: "Architectural Brilliance",
    description:
      "Seamlessly blending creativity and compliance to design visually striking and structurally sound buildings.",
  },
  {
    img: "/Assets/image3.png",
    title: "Excellence in Design",
    description:
      "Meticulous structural planning and execution backed by over 37 years of technical mastery.",
  },
  {
    img: "/Assets/image4.png",
    title: "Eco-Conscious Management",
    description:
      "Approval due diligence — delivering end-to-end solutions for infrastructure and real estate projects.",
  },
  {
    img: "/Assets/image5.png",
    title: "From Vision to Reality",
    description:
      "Your ideas brought to life through comprehensive design and approval due diligence frameworks.",
  },
];

const ImageCarousel = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000); // change slide every 4 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel-container1">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`carousel-slide ${index === current ? "active" : ""}`}
        >
          <img src={slide.img} alt={slide.title} className="carousel-image" loading="lazy" />
          <div className="carousel-caption">
            <h2>{slide.title}</h2>
            <p>{slide.description}</p>
            <button 
              className="quote-btn"
              onClick={() => window.open('https://forms.gle/ER7Qi6oNf2A2CRGm8', '_blank')}
            >
              Get a Quote
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImageCarousel;
